<template>
  <div>
    <topsearch :title="'Admin / ' + permissionDetail.name" />
    <div class="flex">
      <div class="w-72   border-r h-full" style="min-width:217px">
        <adminSidebar />
      </div>
      <div class="w-full">
        <template v-if="table">
          <Datatable
            :table="table"
            :permissions="permissionDetail"
            editModal="true"
            :tablename="permissionDetail.name"
            detailurl="/detail/"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Datatable from "../components/Datatable/Table";
import SidebarVue from "../components/Ui/Admin/Sidebar.vue";
export default {
  name: "adminPage",
  components: { Datatable, adminSidebar: SidebarVue },
  data() {
    return {
      table: null,
      permissionMap: [],
      tableInfo: {}
    };
  },
  computed: {
    permissionDetail() {
      var permissions = this.$root.cache && this.$root.cache.permissions;
      return (permissions && permissions.find(e => e.table == this.table)) || { name: '', table: '' };
    }
  },
  watch: {
    $route(to, from) {
      this.table = this.$route.params.table;
    }
  },
  created() {
    this.table = this.$route.params.table;
  }
};
</script>
